<div class="filter-for-list">

  <h3 *ngIf="!readOnly"><span *ngIf="!idProject" [innerHtml]="('ADD_PROJECT' | translate) + ' : '"></span><span
    *ngIf="idProject" [innerHtml]="('EDIT_PROJECT' | translate) + ' : '"></span>{{projectForm?.value?.name}}
  </h3>
  <h3 *ngIf="readOnly">{{projectForm?.value?.name}}
  </h3>

</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>


<div class="modal-body formModal" *ngIf="!readOnly">
  <mat-horizontal-stepper [linear]="!idProject" #stepper [selectedIndex]="selectedStep">

    <mat-step [stepControl]="projectForm">
      <ng-template matStepLabel>{{'INFORMATION'|translate}}</ng-template>
      <app-project-information [projectForm]="projectForm" [project]="project"
                               *ngIf="stepper._getFocusIndex() === 0 && !showSpinner"></app-project-information>
      <div>
        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
          Next
        </button>
      </div>
    </mat-step>

    <mat-step [stepControl]="projectAddressForm">
      <ng-template matStepLabel>{{'ADDRESS' | translate}}</ng-template>
      <app-project-address *ngIf="stepper._getFocusIndex() === 1 && !showSpinner" [project]="project"
                           [projectAddressForm]="projectAddressForm"></app-project-address>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
          Next
        </button>
      </div>
    </mat-step>


    <mat-step>
      <ng-template matStepLabel>{{'CHECK_SAVE' | translate}}</ng-template>


      <app-project-information [projectForm]="projectForm"
                               *ngIf="stepper._getFocusIndex() === 2" [readOnly]="true"
                               disableEditionButton="true"></app-project-information>


      <app-project-address *ngIf="stepper._getFocusIndex() === 2" [project]="project"
                           [projectAddressForm]="projectAddressForm" [readOnly]="true"
                           disableEditionButton="true"></app-project-address>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button type="button" class="btn btn-info" routerLink="/projects">
          {{'RETURN_TO_PROJECTS_LIST'|translate}}
        </button>
        <button type="button" class="btn btn-warning" (click)="saveProject()">
          <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
          {{'SAVE'|translate}}
        </button>
        <button *ngIf="idProject" class="btn btn-info" mat-button matStepperNext
                [innerHTML]="'NEXT_BUTTON' | translate">Next
        </button>
      </div>
    </mat-step>
    <!--USERS-->
    <mat-step *ngIf="idProject">
      <ng-template matStepLabel>{{'USERS' | translate}}</ng-template>

      <app-project-user-remove-list *ngIf="stepper._getFocusIndex() === 3 && !showSpinner" [projectId]="idProject"
                                    [projectLevel]="project.level"></app-project-user-remove-list>


      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>

        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next
        </button>
      </div>
    </mat-step>

    <mat-step *ngIf="idProject">
      <ng-template matStepLabel>{{'DEVICES' | translate}}</ng-template>
      <app-project-device [projectId]="idProject"
                          *ngIf="stepper._getFocusIndex() === 4 && !showSpinner"></app-project-device>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next
        </button>
      </div>
    </mat-step>


    <mat-step *ngIf="idProject">
      <ng-template matStepLabel>{{'LOCATION' | translate}}</ng-template>
      <app-project-location [projectId]="idProject"
                            *ngIf="stepper._getFocusIndex() === 5 && !showSpinner"></app-project-location>
      <div>
        <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
          Back
        </button>
        <button type="button" class="btn btn-info" routerLink="/projects">
          {{'RETURN_TO_PROJECTS_LIST'|translate}}
        </button>
      </div>
    </mat-step>

  </mat-horizontal-stepper>


</div>

<div class="modal-body formModal" *ngIf="readOnly">

  <app-project-information [projectForm]="projectForm"
                           *ngIf=" !showSpinner" [readOnly]="true"></app-project-information>


  <app-project-address *ngIf=" !showSpinner" [project]="project"
                       [projectAddressForm]="projectAddressForm" [readOnly]="true"></app-project-address>
  <br clear="both"/>

  <app-project-user-remove-list *ngIf="!showSpinner" [projectId]="idProject"
                                [projectLevel]="project.level" [readOnly]="true"></app-project-user-remove-list>

  <br clear="both"/>
  <app-project-device [projectId]="idProject"
                      *ngIf="!showSpinner" [readOnly]="true"></app-project-device>

  <br clear="both"/>
  <app-project-location [projectId]="idProject"
                        *ngIf=" !showSpinner" [readOnly]="true"></app-project-location>
  <br clear="both"/>

  <app-project-edas-alarms [projectId]="idProject" ></app-project-edas-alarms>
  <br clear="both"/>

</div>
